import { ProgramTypes, ProgramState } from "../types/programTypes";

const initialState: ProgramState = {
  onboard: {
    data: null,
    status: "idle",
    error: null,
  },
  metrics: {
    data: null,
    status: "idle",
    error: null,
  },
  detail: {
    data: null,
    cardType: null,
    status: "idle",
    error: null,
  },
};

const programReducer = (state = initialState, action: any): ProgramState => {
  switch (action.type) {
    case ProgramTypes.GET_PROGRAM_ONBOARD_REQUEST:
      return {
        ...state,
        onboard: {
          ...state.onboard,
          status: "loading",
          error: null,
        },
      };

    case ProgramTypes.GET_PROGRAM_ONBOARD_SUCCESS:
      return {
        ...state,
        onboard: {
          data: action.payload?.data || null,
          status: "succeeded",
          error: null,
        },
      };

    case ProgramTypes.GET_PROGRAM_ONBOARD_FAILURE:
      return {
        ...state,
        onboard: {
          data: null,
          status: "failed",
          error: action.payload?.message || "Failed to retrieve program onboard data",
        },
      };

    case ProgramTypes.GET_PROGRAM_METRICS_REQUEST:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          status: "loading",
          error: null,
        },
      };

    case ProgramTypes.GET_PROGRAM_METRICS_SUCCESS:
      return {
        ...state,
        metrics: {
          data: action.payload?.data || null,
          status: "succeeded",
          error: null,
        },
      };

    case ProgramTypes.GET_PROGRAM_METRICS_FAILURE:
      return {
        ...state,
        metrics: {
          data: null,
          status: "failed",
          error: action.payload?.message || "Failed to retrieve program metrics data",
        },
      };

    case ProgramTypes.GET_PROGRAM_DETAIL_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          cardType: action.meta?.cardType || null,
          status: "loading",
          error: null,
        },
      };

    case ProgramTypes.GET_PROGRAM_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          data: action.payload?.data || null,
          cardType: action.meta?.cardType || state.detail.cardType,
          status: "succeeded",
          error: null,
        },
      };

    case ProgramTypes.GET_PROGRAM_DETAIL_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          data: null,
          status: "failed",
          error: action.payload?.message || "Failed to retrieve program detail data",
        },
      };

    default:
      return state;
  }
};

export default programReducer;
